import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=42f7e994"
import script from "./Testimony.vue?vue&type=script&lang=js"
export * from "./Testimony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports